export default "__VITE_ASSET__CfMZvOKa__"